import React, { useState } from 'react';
import Nikewishlist from './resolvers/nikewishlist';
import NikeApp from './resolvers/nikeapp';
const SetCookie = () => {
  const [token, setToken] = useState('')
  function myChangeHandler(event) {
    setToken(event.target.value.replace(/['"]/g, ''))
  }

  function mySubmitHandler(event) {
    event.preventDefault();
    localStorage.setItem('Authorization', `Bearer ${token}`);
    window.location.href = '/'
  }
  return (
    <>
      <h1>CheekyBricki Wishlist Setup</h1>
      <a href="https://www.nike.com/pl/"> NIKE </a>
      <p>await window.webShellClient?.identity?.getAccessToken?.()</p>
      <p>TOKEN RESETUJE SIĘ CO GODZINĘ</p>
      <textarea
        type='text'
        placeholder="access_token:"
        size='60'
        style={{
          height: '400px',
          width: '500px',
          resize: 'none'
        }}
        onChange={myChangeHandler}
      />
      <br />
      <button
        style={{
          height: '30px',
          width: '90px'
        }}
        type='submit'
        onClick={mySubmitHandler}
      >PRZEŚLIJ</button>
      <p>by cwibel#0001</p>
    </>

  );
}



const App = () => {
  function resolve() {
    const searchParams = new URLSearchParams(window.location.search);
    const provider = searchParams.get('provider');

    if (searchParams.get('done')) {
      return <div>Nie udało się dodać do wishlisty</div>
    }

    switch (provider) {
      case 'nikewishlist':
        return <Nikewishlist url={`https://api.nike.com/buy/list_items/v1/`} />
      case 'nikeapp':
        return <NikeApp />
      default:
        return <SetCookie />;
    }
  }

  return resolve()
}

export default App